export default (phone) => {
  if(phone) {
    let phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return phone.replace(phoneRegex, '($1) $2-$3');
  }
  return phone;
};